import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import { Outlet } from 'react-router-dom'
import AgeFeedbackPage from './AgeFeedbackPage'
import AgeQuestionPage from './AgeQuestionPage'
import AnalyzingPage from './AnalyzingPage'
import AvailabilityQuestionPage from './AvailabilityQuestionPage'
import ChallengeFeedbackPage from './ChallengeFeedbackPage'
import ChallengeQuestionPage from './ChallengeQuestionPage'
import CommFeedbackPage from './CommFeedbackPage'
import CommStyleQuestionPage from './CommStyleQuestionPage'
import CompanionStyleFeedbackPage from './CompanionStyleFeedbackPage'
import CompanionStyleQuestionPage from './CompanionStyleQuestionPage'
import ConnectionQuestionPage from './ConnectionQuestionPage'
import DealbreakersQuestionPage from './DealbreakersQuestionPage'
import DealbreaksFeedbackPage from './DealbreaksFeedbackPage'
import FeelingsFeedbackPage from './FeelingsFeedbackPage'
import FrequencyFeedbackPage from './FrequencyFeedbackPage'
import FrequencyQuestionPage from './FrequencyQuestionPage'
import GenderQuestionPage from './GenderQuestionPage'
import GoalFeedbackPage from './GoalFeedbackPage'
import GoalQuestionPage from './GoalQuestionPage'
import MoodPage from './MoodPage'
import NameFeedbackPage from './NameFeedbackPage'
import NameInputPage from './NameInputPage'
import PersonalityQuestionPage from './PersonalityQuestionPage'
import RelationshipQuestionPage from './RelationshipQuestionPage'
import SplashPage from './SplashPage'
import SummaryPage from './SummaryPage'
import TopicsFeedbackPage from './TopicsFeedbackPage'
import TopicsQuestionPage from './TopicsQuestionPage'

const onboardingRoutes = [
  {
    path: '',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        path: 'welcome',
        element: <GenderQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'intro',
        element: <SplashPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'name',
        element: <NameInputPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'name-feedback',
        element: <NameFeedbackPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'companion-style',
        element: <CompanionStyleQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'companion-style-feedback',
        element: <CompanionStyleFeedbackPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'connection',
        element: <ConnectionQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'age',
        element: <AgeQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'age-feedback',
        element: <AgeFeedbackPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'goal',
        element: <GoalQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'goal-feedback',
        element: <GoalFeedbackPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'relationship',
        element: <RelationshipQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'feelings',
        element: <MoodPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'feelings-feedback',
        element: <FeelingsFeedbackPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'challenge',
        element: <ChallengeQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'challenge-feedback',
        element: <ChallengeFeedbackPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'comm-style',
        element: <CommStyleQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'comm-feedback',
        element: <CommFeedbackPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'personality',
        element: <PersonalityQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'topics',
        element: <TopicsQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'topics-feedback',
        element: <TopicsFeedbackPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'availability',
        element: <AvailabilityQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'frequency',
        element: <FrequencyQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'frequency-feedback',
        element: <FrequencyFeedbackPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'dealbreakers',
        element: <DealbreakersQuestionPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'deal-feedback',
        element: <DealbreaksFeedbackPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'summary',
        element: <SummaryPage />,
        action: navigateToNextOnboardingPageAction,
      },
      {
        path: 'analyzing',
        element: <AnalyzingPage />,
        action: navigateToNextOnboardingPageAction,
      },
    ],
  },
]

export default onboardingRoutes
